import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export const websiteServicesConf = {
  ME_SOIGNER: { label: "Me soigner" },
  PHARMONWEB: { label: "Pharmonweb" },
  PHARMANITY: { label: "Pharmanity" },
  VALWIN: { label: "Valwin" },
  AUTRE: { label: "Autre" },
} as const satisfies ReferentialEnum

export type WebsiteServicesName = keyof typeof websiteServicesConf

export const websiteServicesReferential =
  referentialEnumToReferentialCodeList(websiteServicesConf)
